"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var SvgUserInset = function SvgUserInset(_ref) {
  var svgRef = _ref.svgRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef"]);
  props.className = (0, _classnames.default)('Icon', props.className);
  return _react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef
  }, props), _react.default.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512,
    fill: "none"
  }), _react.default.createElement("path", {
    d: "M888 859.5C794.5 960.6 660.7 1024 512 1024c-148.5 0-282.2-63.2-375.7-164.2 36.3-174.3 190.8-305.2 375.9-305.2 185 0 339.4 130.7 375.8 304.9zM512 0C229.2 0 0 229.2 0 512c0 115.3 38.1 221.7 102.4 307.2 41.3-142.3 154.8-253.9 298.3-292.5C327.3 487 277.3 409.3 277.3 320c0-129.6 105.1-234.7 234.7-234.7S746.7 190.4 746.7 320c0 62.2-24.7 121.9-68.7 165.9-16.3 16.3-34.8 30-54.7 40.7 143.4 38.6 257 150.2 298.5 292.4C986 733.5 1024 627.2 1024 512 1024 229.2 794.8 0 512 0zm192 320c0-106-86-192-192-192s-192 86-192 192 86 192 192 192 192-86 192-192z"
  }));
};

var ForwardRef = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(SvgUserInset, (0, _extends2.default)({
    svgRef: ref
  }, props));
});

var _default = ForwardRef;
exports.default = _default;